export default __webpack_public_path__ + "static/media/pay-advice-icon.6518e849.svg";